module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_fotbal-4e754e490e78984791f1532bbbe8227d.mp4";